import Navbar from "@/components/landing/Navbar";
import DiagnosticHero from "@/components/diagnostic/DiagnosticHero";
import BrandStatement from "@/components/landing/BrandStatement";
import CapitalDeMarca from "@/components/landing/CapitalDeMarca";
import MethodIntro from "@/components/landing/MethodIntro";
import Challenge from "@/components/landing/Challenge";
import Solution from "@/components/landing/Solution";
import Pricing from "@/components/landing/Pricing";
import CapitalDilution from "@/components/landing/CapitalDilution";
import AboutUs from "@/components/landing/AboutUs";
import Stats from "@/components/landing/Stats";
import Testimonials from "@/components/landing/Testimonials";
import PowerQuote from "@/components/landing/PowerQuote";
import Exclusivity from "@/components/landing/Exclusivity";
import ClosingCTA from "@/components/landing/ClosingCTA";
import CalendlySection from "@/components/landing/CalendlySection";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";

const Index = () => {
  return (
    <main className="min-h-screen bg-background">
      <Navbar />
      {/* Hero: Promesa del diagnóstico */}
      <DiagnosticHero />
      {/* Brand Statement */}
      <BrandStatement />
      {/* Capital de Marca */}
      <CapitalDeMarca />
      {/* Introducción al método */}
      <MethodIntro />
      {/* 1) Puntos de dolor (El Desafío) */}
      <Challenge />
      {/* 2) Arquitectura / Solución */}
      <Solution />
      {/* 2.3) CORESSEN CAPITAL */}
      <Pricing />
      {/* 2.5) Dilución del capital */}
      <CapitalDilution />
      {/* 3) Quiénes somos */}
      <AboutUs />
      {/* 4) Los arquitectos - Trayectoria global */}
      <Stats />
      {/* 5) Exclusividad */}
      <Exclusivity />
      {/* 6) Testimonios */}
      <Testimonials />
      {/* 7) El valor de tu trayectoria */}
      <PowerQuote />
      {/* 8) Calendly */}
      <CalendlySection />
      {/* 9) CTA Final - Hablar con un consultor */}
      <ClosingCTA />
      {/* Footer */}
      <Footer />
      <WhatsAppButton />
    </main>
  );
};

export default Index;
